import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MeesmaService {

  private _socket!: Socket;
  isAuthenticated = false
  room!: string

  initConnection(room: string) {
    this._socket = io(environment.url_be, {
      transports: ['websocket'],
      query: { room: room }
    });
    this._socket.on("connect", () => {
      // Todo:
    })
  }

  disconnect() {
    this._socket?.disconnect();
  }

  get id() {
    return this._socket.id;
  }

  public on(eventName: string, callback: (data: any) => void): void {
    this._socket.on(eventName, callback);
  }

  public emit(type: string, data: any): void {
    this._socket.emit("message", {
      type: type,
      data: data
    });
  }

  public off(eventName: string): void {
    this._socket.off(eventName);
  }

  public clearSession() {
    sessionStorage.clear();
  }
}

